module.exports = __webpack_public_path__ + "img/poly-10.1c4c6ea7.png";